module.exports = __webpack_public_path__ + "static/sw-logo-black-e8cb46ce7b631031e43b947230d6e98f.png";